import React, { Suspense, lazy, ComponentType } from 'react';
import RouteLoader from 'Components/common/RouteLoader';

const withRouteSuspense = (LazyComponent: React.LazyExoticComponent<ComponentType<any>>) => {
  const Wrapped = function WrappedRoute(props: Record<string, unknown>) {
    return (
      <Suspense fallback={<RouteLoader />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
  return Wrapped;
};

export const Articles = withRouteSuspense(lazy(() => import('Pages/dailyIq/DailyIq')));
export const DailyIQCompanies = withRouteSuspense(lazy(() => import('Pages/dailyIq/DailyIQCompanies')));
export const GuestSearch = withRouteSuspense(lazy(() => import('Pages/search/GuestSearchResults')));
export const SimilarPeople = withRouteSuspense(lazy(() => import('Pages/person/SimilarPeople')));
export const ArcTypes = withRouteSuspense(lazy(() => import('Pages/arctypes/ArcTypes')));
export const CustomWidget = withRouteSuspense(lazy(() => import('Pages/customWidget/CustomWidget')));
export const Settings = withRouteSuspense(lazy(() => import('Pages/person/Settings')));
export const Favorites = withRouteSuspense(lazy(() => import('Pages/person/Favorites')));
export const AdvanceSearchResults = withRouteSuspense(lazy(() => import('Pages/search/AdvanceSearchResults')));
export const SalesforceRouter = withRouteSuspense(lazy(() => import('Components/Salesforce/SalesforceRouter')));
export const DeepLinkView = withRouteSuspense(lazy(() => import('deeplinking/DeepLinkView')));
export const Login = withRouteSuspense(lazy(() => import('Pages/auth/Login')));
export const SSO = withRouteSuspense(lazy(() => import('Pages/auth/SSO')));
export const Onboardingv2 = withRouteSuspense(lazy(() => import('Pages/onboardingRevamp/Onboarding')));
